import * as React from "react";
const SvgFiBrandsNodeJs = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-node-js_svg__a)">
      <path
        fill="#151A2D"
        fillRule="evenodd"
        d="M12.569.152a1.14 1.14 0 0 0-1.136 0L2.026 5.58a1.14 1.14 0 0 0-.568.984V17.43c0 .406.217.78.568.984l9.407 5.433c.352.203.785.203 1.137 0l9.405-5.433c.351-.203.568-.578.568-.984V6.565c0-.406-.217-.781-.568-.984z"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-node-js_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsNodeJs;
